import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=3bac766a&scoped=true"
import script from "./custom-select.vue?vue&type=script&lang=ts"
export * from "./custom-select.vue?vue&type=script&lang=ts"
import style0 from "./custom-select.vue?vue&type=style&index=0&id=3bac766a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac766a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bac766a')) {
      api.createRecord('3bac766a', component.options)
    } else {
      api.reload('3bac766a', component.options)
    }
    module.hot.accept("./custom-select.vue?vue&type=template&id=3bac766a&scoped=true", function () {
      api.rerender('3bac766a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dropdown/custom-select.vue"
export default component.exports